var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { prepareAudioChallenge, handleWord, getstats, handleStats, learned, shuffle, } from '../../common/functions';
import { Controls } from '../controls/controls';
import { Dots } from '../dots/dots';
import { PostGame } from '../endscreen/postgamescreen';
import './gameboard.css';
import { Preloader } from './preloader';
import ClearIcon from '@mui/icons-material/Clear';
import { Link } from 'react-router-dom';
export function AudioChallenge(props) {
    var _this = this;
    var _a = useState([]), items = _a[0], setItems = _a[1];
    var _b = useState(false), load = _b[0], isLoad = _b[1];
    var _c = useState(false), finish = _c[0], isFinish = _c[1];
    var _d = useState(0), counter = _d[0], setCounter = _d[1];
    var _e = useState([]), guessed = _e[0], setGuessed = _e[1];
    var _f = useState({
        new: 0,
        answers: 0,
        correctAnswers: 0,
        learned: 0,
        bigStreak: 0,
    }), statsData = _f[0], setStatsData = _f[1];
    var _g = useState(false), loadstats = _g[0], isLoadstats = _g[1];
    var _h = useState({}), userStats = _h[0], setUserStats = _h[1];
    var _j = useState(0), streak = _j[0], setStreak = _j[1];
    var _k = useState(false), noWords = _k[0], setnoWords = _k[1];
    useEffect(function () {
        var resp = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, prepareAudioChallenge(props === null || props === void 0 ? void 0 : props.page, props === null || props === void 0 ? void 0 : props.group, props === null || props === void 0 ? void 0 : props.fromPage)];
                    case 1:
                        response = _a.sent();
                        setItems(response);
                        isLoad(true);
                        if (response.length === 0) {
                            setnoWords(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        resp();
    }, [props === null || props === void 0 ? void 0 : props.fromPage, props === null || props === void 0 ? void 0 : props.group, props === null || props === void 0 ? void 0 : props.page]);
    useEffect(function () {
        function loadstats() {
            return __awaiter(this, void 0, void 0, function () {
                var resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getstats()];
                        case 1:
                            resp = _a.sent();
                            if (resp) {
                                isLoadstats(true);
                                setUserStats(resp);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        loadstats();
    }, [finish]);
    useEffect(function () {
        function qwer() {
            if (loadstats)
                handleStats(userStats, statsData, 'audiochallenge');
        }
        window.addEventListener('beforeunload', qwer);
        return function () {
            window.removeEventListener('beforeunload', qwer);
        };
    }, [loadstats, statsData, userStats]);
    function reset() {
        setStatsData(function () {
            return { new: 0, answers: 0, correctAnswers: 0, learned: 0, bigStreak: 0 };
        });
        isFinish(false);
        setCounter(0);
        setGuessed([]);
        setItems(filterItems());
    }
    function updateData(element) {
        var _a, _b;
        var a = (_b = (_a = items[counter].properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown;
        var b = items[counter].isNew;
        var strk = streak;
        if (items[counter].wordTranslate === element) {
            strk += 1;
            setStreak(streak + 1);
            items[counter].guessedCorrect = true;
            setGuessed(function (guessed) { return __spreadArray(__spreadArray([], guessed, true), [items[counter]], false); });
            handleWord(items[counter], true, 'audiochallenge');
        }
        else {
            strk = 0;
            setStreak(0);
            items[counter].guessedCorrect = false;
            setGuessed(function (guessed) { return __spreadArray(__spreadArray([], guessed, true), [items[counter]], false); });
            handleWord(items[counter], false, 'audiochallenge');
        }
        setStatsData(function (statsData) {
            var _a, _b;
            return (statsData = {
                new: statsData.new + (b ? 1 : 0),
                answers: statsData.answers + 1,
                correctAnswers: statsData.correctAnswers + (items[counter].guessedCorrect ? 1 : 0),
                learned: statsData.learned +
                    learned(a, (_b = (_a = items[counter].properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown),
                bigStreak: statsData.bigStreak > strk ? statsData.bigStreak : strk,
            });
        });
    }
    function updateCounter() {
        if (counter !== items.length - 1) {
            setCounter(counter + 1);
        }
        else {
            isFinish(true);
            setStatsData(function () {
                return {
                    new: 0,
                    answers: 0,
                    correctAnswers: 0,
                    learned: 0,
                    bigStreak: 0,
                };
            });
            if (loadstats) {
                handleStats(userStats, statsData, 'audiochallenge');
            }
        }
    }
    function filterItems() {
        items.forEach(function (element) { return (element.variant = shuffle(element.variant)); });
        if (!(props === null || props === void 0 ? void 0 : props.fromPage))
            return shuffle(items);
        else {
            var filtered = items.filter(function (element) { var _a, _b; return !((_b = (_a = element.properties) === null || _a === void 0 ? void 0 : _a.optional) === null || _b === void 0 ? void 0 : _b.isKnown); });
            if (filtered.length > 0)
                return shuffle(filtered);
            else {
                setnoWords(true);
                return items;
            }
        }
    }
    if (!load && !finish) {
        return React.createElement(Preloader, null);
    }
    else if (noWords) {
        return (React.createElement("div", { className: "gameboard" },
            React.createElement(Link, { to: "/", className: "exit_link" },
                React.createElement(ClearIcon, { onClick: function () {
                        if (load)
                            handleStats(userStats, statsData, 'sprint');
                    }, sx: { fontSize: 40, color: 'white' } })),
            "\u0412\u044B \u043E\u0442\u0433\u0430\u0434\u0430\u043B\u0438 \u0432\u0441\u0435 \u0441\u043B\u043E\u0432\u0430. \u0412\u044B\u0439\u0434\u0438\u0442\u0435 \u0438\u0437 \u0438\u0433\u0440\u044B \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F \u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0443\u0447\u0435\u0431\u043D\u0438\u043A\u0430"));
    }
    else if (!finish) {
        return (React.createElement("div", { className: "gameboard" },
            React.createElement(Link, { to: "/", className: "exit_link" },
                React.createElement(ClearIcon, { onClick: function () {
                        if (loadstats)
                            handleStats(userStats, statsData, 'audiochallenge');
                    }, sx: { fontSize: 40, color: 'white' } })),
            React.createElement("div", null,
                React.createElement(Dots, { arr: items, guessed: guessed })),
            React.createElement("div", null,
                React.createElement(Controls, { items: items, updatefunc: updateData, counter: counter, load: load, updatecount: updateCounter }))));
    }
    else
        return (React.createElement("div", { className: "gameboard" },
            React.createElement(Link, { to: "/", className: "exit_link" },
                React.createElement(ClearIcon, { onClick: function () {
                        if (loadstats)
                            handleStats(userStats, statsData, 'audiochallenge');
                    }, sx: { fontSize: 40, color: 'white' } })),
            React.createElement(PostGame, { guessed: guessed, reset: reset })));
}
